
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
	anchor.addEventListener('click', function (e) {
		e.preventDefault();

		const targetId = this.getAttribute('href').substring(1);
		const targetElement = document.getElementById(targetId);

		if (targetElement) {
			targetElement.scrollIntoView({ behavior: 'smooth' });
		}
	});
});

// document.querySelectorAll('.menu .menu-item-has-children > a').forEach(function (menuItem) {
// 	menuItem.addEventListener('click', function (event) {
// 		event.preventDefault(); // Prevent the default action of the link

// 		const parentMenuItem = this.parentElement;
// 		const isActive = parentMenuItem.classList.contains('active');

// 		// Remove 'active' class from all menu items
// 		document.querySelectorAll('#primary-menu .menu-item-has-children').forEach(function (item) {
// 			item.classList.remove('active');
// 		});

// 		// Toggle 'active' class on the clicked menu item
// 		if (!isActive) {
// 			parentMenuItem.classList.add('active');
// 		} else {
// 			parentMenuItem.classList.remove('active');
// 		}

// 		event.stopPropagation();
// 	});
// });


document.querySelectorAll('.menu .menu-item-has-children').forEach(function (menuItem) {
	menuItem.addEventListener('click', function (event) {
		const isActive = this.classList.contains('active');

		document.querySelectorAll('.menu .menu-item-has-children').forEach(function (item) {
			item.classList.remove('active');
		});

		if (!isActive) {
			this.classList.add('active');
		}

		event.stopPropagation();
	});
});

document.querySelector('.open-nav').addEventListener('click', function () {
	document.querySelector('.mob-nav').classList.add('active');
	document.body.classList.add('hidden');
});

document.querySelector('.close-btn').addEventListener('click', function () {
	document.querySelector('.mob-nav').classList.remove('active');
	document.body.classList.remove('hidden');
});

setTimeout(function () {
	document.getElementById('preloader').classList.add('hidden');
}, 3000);

document.addEventListener('DOMContentLoaded', function () {
	const faqItems = document.querySelectorAll('.fp-hero--item');
	const accordion = document.querySelectorAll('.accordion--header');

	faqItems.forEach(function (faqItem) {
		faqItem.addEventListener('click', function () {
			var index = faqItem.getAttribute('data-index');
			var accordion = document.getElementById('accordion-' + index);

			// Hide all accordions
			var allAccordions = document.querySelectorAll('.cp-faqs--wrp');
			allAccordions.forEach(function (acc) {
				acc.style.display = 'none';
			});

			// Show the clicked accordion
			accordion.style.display = 'block';
		});
	});

	accordion.forEach(header => {
		header.addEventListener('click', function () {
			const currentActiveItem = document.querySelector('.accordion--item');
			const parentItem = this.parentElement;

			if (currentActiveItem && currentActiveItem !== parentItem) {
				currentActiveItem.classList.remove('active');
			}

			parentItem.classList.toggle('active');
		});
	});
});


jQuery(document).ready(async function ($) {
	$('.clay-dates-v1-slider').slick({
		arrows: true,
		slidesToShow: 1,
	});

	$('.event-cta-slider').slick({
		arrows: true,
		slidesToShow: 1,
	});

	$('.proof-block-v1-slider').slick({
		arrows: true,
		dots: true,
		slidesToShow: 1,
	});

	$('.services-slider').slick({
		arrows: true,
		slidesToShow: 1,
	});

	if ($('.about-page-gallery-v1--gallery-slider').length) {
		$('.about-page-gallery-v1--gallery-slider').slick({
			arrows: true,
			centerMode: true,
			variableWidth: true,
			slidesToShow: 3,
			dots: true
		});

		$('.slick-current.slick-active.slick-center').eq(0).addClass('about-page-gallery-v1--gallery-slider-item__center-img');
		$('.about-page-gallery-v1--gallery-slider .slick-track').addClass('gap-track');

		$('.about-page-gallery-v1--gallery-slider').on('beforeChange', function () {
			$(`.slick-slide`).removeClass('about-page-gallery-v1--gallery-slider-item__center-img');
		})

		$('.about-page-gallery-v1--gallery-slider').on('afterChange', function (event, slick, currentSlide) {
			$(`.slick-slide[data-slick-index="${currentSlide}"]`).addClass('about-page-gallery-v1--gallery-slider-item__center-img');
		})
	}


	$('.cd-data-slider--slider').slick({
		dots: true,
		arrows: false,
		// centerMode: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	})


	$('.cd-team--slider').slick({
		arrows: true,
		slidesToShow: 3,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	})

	$('.cd-slider--items').slick({
		arrows: true,
		slidesToShow: 1,
	})

	$('.ts-showcases--slider').slick({
		arrows: true,
		slidesToShow: 1,
	})

	$('.membership-hero--slider').slick({
		dots: true,
		arrows: true,
		slidesToShow: 1,
	})

	$('.equiptment-accordion-image--slider').each(function () {
		let $slider = $(this);
		let slideCount = $slider.children().length;

		$slider.slick({
			dots: slideCount > 1,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1
		});

		if (slideCount <= 1) {
			$slider.addClass('no-dots');
		}
	});

});
